import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Briefcase, Building2 } from "lucide-react";
import { FormattedMessage } from "react-intl";
import sh from "bundles/common/utils/sh";
import CompanyCard from "bundles/Candidate/components/CompanyCard";
import NewJobOfferCard from "bundles/Candidate/components/NewJobOfferCard";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 32,
  },
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: "1.125rem !important",
    color: "hsl(220 40% 13%)",
    marginBottom: "16px !important",
    fontFamily: "Segoe UI Semibold, system-ui, sans-serif !important",
  },
  icon: {
    width: "1.25rem !important",
    height: "1.25rem !important",
    color: "hsl(152 60% 44%)",
  },
  placeholder: {
    padding: 24,
    borderRadius: 8,
    border: `1px dashed ${theme.palette.divider}`,
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
  companyList: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
}));

const Sidebar = () => {
  const classes = useStyles();
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const authenticityToken = useSelector((state) => state.authenticity_token);
  const [companies, setCompanies] = useState([]);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    sh.get("featured_companies")
      .then((res) => setCompanies((res.data.companies || []).slice(0, 4)))
      .catch((err) => console.error(err));

    sh.get("random_jobs", {
      params: { quantity: 3, authenticity_token: authenticityToken },
    })
      .then((res) => setOffers(res.data?.data || []))
      .catch((err) => console.error(err));
  }, []);

  return (
    <Box className={classes.root}>
      <Box>
        <Typography className={classes.sectionTitle}>
          <Briefcase className={classes.icon} />
          <FormattedMessage id="blog_sidebar.job_offers" />
        </Typography>
        <Box className={classes.companyList}>
          {offers.length > 0 && (
            offers.map((offer) => (
              <NewJobOfferCard
                key={offer.id}
                offer={offer}
                onClick={(o) => {
                  window.location.href = `/${i18nLocale}/jobs/${o?.encoded_job_title}/${o?.id}`;
                }}
              />
            ))
          )}
        </Box>
      </Box>

      {companies.length > 0 && (
        <Box>
          <Typography className={classes.sectionTitle}>
            <Building2 className={classes.icon} />
            <FormattedMessage id="companies_section.heading" />
          </Typography>
          <Box className={classes.companyList}>
            {companies.map((company, index) => (
              <CompanyCard
                key={company.id}
                company={company}
                onClick={() => {
                  window.location.href = `/${i18nLocale}/companies/${company.encoded_name}/${company.id}`;
                }}
                index={index}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Sidebar;
